/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { McpEndpoint, McpEndpoint$inboundSchema } from "./mcpendpoint.js";

/**
 * Result type for listing MCP endpoints
 */
export type ListMcpEndpointsResult = {
  mcpEndpoints: Array<McpEndpoint>;
};

/** @internal */
export const ListMcpEndpointsResult$inboundSchema: z.ZodMiniType<
  ListMcpEndpointsResult,
  unknown
> = z.pipe(
  z.object({
    mcp_endpoints: z.array(McpEndpoint$inboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      "mcp_endpoints": "mcpEndpoints",
    });
  }),
);

export function listMcpEndpointsResultFromJSON(
  jsonString: string,
): SafeParseResult<ListMcpEndpointsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListMcpEndpointsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListMcpEndpointsResult' from JSON`,
  );
}
